import React from 'react'
import { Grid } from '@material-ui/core'
import Avatar from '@mui/material/Avatar'
import Chip, { ChipProps } from '@mui/material/Chip'
import { ImageField, RichTextField } from '@prismicio/types'
import { prismicText } from '@/components/Global/CMSText'
import { evaluateCondition } from '@/utils/evaluateCondition'

type TProductTagProps = {
  text?: RichTextField
  color?: string
  icon?: ImageField
  condition?: string | RichTextField
  data?: unknown
}

const CHIP_COLORS: ChipProps['color'][] = [
  'default',
  'primary',
  'secondary',
  'success',
  'info',
  'warning',
  'error',
]

const resolveChipColor = (value?: string): ChipProps['color'] => {
  if (!value) return 'default'
  const lowerCased = value.toLowerCase() as ChipProps['color']
  return CHIP_COLORS.includes(lowerCased) ? lowerCased : 'default'
}

const ProductTag = ({
  text,
  color,
  icon,
  condition,
  data,
}: TProductTagProps) => {
  const label = prismicText(text)
  if (!label) return null

  const chipColor = resolveChipColor(color)
  const shouldDisplay = evaluateCondition(condition, { data: data || {} })
  if (!shouldDisplay) return null

  const chipAvatar = icon?.url ? (
    <Avatar
      src={icon.url}
      alt={icon.alt || label}
      className="product-dynamic-tag__avatar"
    />
  ) : undefined

  return (
    <Grid item sm="auto" className="product-dynamic-tag">
      <Chip
        label={label}
        color={chipColor}
        avatar={chipAvatar}
        className="product-dynamic-tag__chip"
      />
    </Grid>
  )
}

export default ProductTag
